import { render } from "./ipserupinfo.vue?vue&type=template&id=4bea956d"
import script from "./ipserupinfo.vue?vue&type=script&lang=js"
export * from "./ipserupinfo.vue?vue&type=script&lang=js"
script.render = render

export default script